import React from 'react';
import PropTypes from 'prop-types';

import useTrackingsStatus from 'app/hooks/useTrackingsStatus.hook';

import './TrackingStatusFormatter.scss';
import { Colors } from 'app/utils/colors';

export const TrackingStatusFormatter = ({
  status = null,
  possibleDelay = false
}) => {
  const trackingsStatus = useTrackingsStatus();

  if (!status) return null;

  const statusColor = possibleDelay
    ? '#EF6327'
    : trackingsStatus[status]?.color;
  const statusBackgroundColor = possibleDelay
    ? '#FCE7DF'
    : trackingsStatus[status]?.backgroundColor;

  return (
    <div
      className="tracking-status-formatter"
      style={{
        backgroundColor: statusBackgroundColor || Colors.bbGrey8,
        color: statusColor || Colors.bbGrey1
      }}
    >
      {trackingsStatus[status]?.translation}
    </div>
  );
};

TrackingStatusFormatter.propTypes = {
  status: PropTypes.string,
  possibleDelay: PropTypes.bool
};
